<template>
  <div class="Corporatehonors">
<!--    <caidan></caidan>-->
    <div class="CaiDanBottom"></div>
    <div class="honors-container">
      <div class="banner-container">
        <img class="img-about" src="@/assets/about/1111.jpg">
      </div>
      <breadcrumb class="breadcrumb"></breadcrumb>
      <div class="content-container">
        <honor></honor>
      </div>
      <bottom class="bottom-container"></bottom>
    </div>
  </div>
</template>

<script>
import caidan from "@/components/caidan.vue";
import Breadcrumb from "@/components/breadcrumb.vue";
import honor from "@/components/About/Corporatehonors.vue";

export default {
  name: "Corporatehonors",
  components: {Breadcrumb, honor, caidan},
};
</script>

<style scoped>
.Corporatehonors {
  width: 100%;
}

.honors-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .CaiDanBottom{
    height:100px;
    width: 100%;
  }
}
.banner-container {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  margin-bottom:0;
  display: block;
  background-color: white;
}

.img-about {
  width: 100%;
  display: block;
  height: auto;
  max-width: none;
}

.content-container {
  width: 100%;
  margin-top: 5%;
  margin-bottom: 5%;
}

.bottom-container {
  width: 100%;

}


</style>
